"use client";

import React from "react";

import ErrorPage from "../../molecules/ErrorPage/ErrorPage.component";
import { useTranslations } from "next-intl";


const NotFound: React.FC = () => {
  const t = useTranslations()
  
  const NOT_FOUND_CONTENT = {
    title: t("404.title"),
    image: {
      src: "/masks/404.svg",
      get alt() {
        return NOT_FOUND_CONTENT.title;
      },
    },
  };

  return (
    <ErrorPage
      title={NOT_FOUND_CONTENT.title}
      image={NOT_FOUND_CONTENT.image}
    />
  );
};

export default NotFound;
